import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { loadRuntimeConfig } from './config/runtimeConfig';

loadRuntimeConfig().then(() => {
  createRoot(document.getElementById('root')).render(
    <React.StrictMode><App /></React.StrictMode>,
  );
}).catch(error => {
  const message = document.createElement('p');
  message.setAttribute('role', 'alert');
  message.textContent = `${error.message}. Check the deployed config.json and refresh the page.`;
  document.getElementById('root').replaceChildren(message);
});
